export const SET_TARGET_MILLISECONDS = "SET_TARGET_MILLISECONDS";
export const TOGGLE_START_PAUSE = "TOGGLE_START_PAUSE";
export const TOGGLE_ACTIVE = "TOGGLE_ACTIVE";
export const TOGGLE_BUTTON_VISIBILITY = "TOGGLE_BUTTON_VISIBILITY";
export const SET_INPUT_VALUE = "SET_INPUT_VALUE";
export const SET_TOTAL_TIME = "SET_TOTAL_TIME";
export const TOGGLE_SET = "TOGGLE_SET";
export const RESET_STOPWATCH = "RESET_STOPWATCH";
export const SET_TARGET_AND_CURRENT_MILLISECONDS =
  "SET_TARGET_AND_CURRENT_MILLISECONDS";
export const TICK = "TICK"; // Decrement the milliseconds for the timer tick
